<template>
    <div class="user-panel">
        <!-- ライセンスが無いときは非表時ー-->
        <template v-if="!show">
            <div style="text-align:center;padding-top:40px">
                {{ $t('message.error_need_call_option') }}
            </div>
        </template>

        <!-- ライセンスがあるときは設定表示 -->
        <template v-else>
            <div class="object-titlebox">
                <div class="object-titlebox-left" v-t="'message.item_buddycom_call_setting'"></div>
                <div class="object-titlebox-right">
                    <button class="transparent-button" type="button"
                            v-on:click="checkBrowserToShowBuddycomCallSetting()">
                        <img src="@/assets/edit.svg"/>
                        <span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                    </button>
                </div>
            </div>

            <div class="object-inner-table">
                <table width=100%>
                    <!--- 設定内容 --->
                    <tr class="object-titlebox" style="display: table-row;">
                        <td class="object-titlebox-text" style="padding-left: 20px; width:100%;"
                            v-t="'message.item_setting_value'"></td>
                        <td class="object-titlebox-text"></td>
                    </tr>

                    <!-- Gifカテゴリー -->
                    <tr class="objectitem-record">
                        <td class="object-item" v-t="'message.item_buddycom_call_gif_category'"></td>
                        <td class="object-right-value" style="text-align: center;">{{ gifSelectedType.label }}</td>
                    </tr>

                    <!-- 画面オフ時の画像 -->
                    <tr class="objectitem-record">
                        <td class="object-item" v-t="'message.item_buddycom_call_camera_off_image'"></td>
                        <td class="object-right-value" style="text-align: center;">
                            <div class="object-right-value-image-container">
                                <img
                                    class="object-right-value-image"
                                    :src="buddycomCallSettingInfo.imageUrl"
                                    alt="画面off時の画像"
                                />
                            </div>
                        </td>
                    </tr>

                </table>
            </div>

            <!-- @save は、子コンポーネント（editBuddycomCallSetting）がsave イベントを発火したときに呼び出される（親の）メソッドを指定する記法
            　　　showBuddycomCallSetting が true のときだけ <editBuddycomCallSetting /> とそのイベントリスナー（@save, @cancel）が有効
            　　　:buddycomCallSettingInfo="buddycomCallSettingInfo  左側は「子コンポーネント側のprops名」 右側は「親のデータ名」
                子コンポーネント（editBuddycomCallSetting）で saveChangeが処理された時に呼ばれ、modifyBuddycomCallSettingが（引数を受け取り）実行される
            -->
            <editBuddycomCallSetting v-if="showBuddycomCallSetting" @cancel="showBuddycomCallSetting = false"
                                     @save="modifyBuddycomCallSetting"
                                     :buddycomCallSettingInfo="buddycomCallSettingInfo"/>
        </template>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import EditBuddycomCallSetting from "./EditBuddycomCallSetting.vue";
import callCameraOff from "@/assets/call_camera_off.svg";

export default {

    // テンプレート内で <editBuddycomCallSetting> を使えるようにするために登録
    components: {
        editBuddycomCallSetting: EditBuddycomCallSetting,
    },

    data() {
        return {
            show: false,
            showBuddycomCallSetting: false,
            gifCategoryList: [],
            gifSelectedType: {value: null, label: ''},
            buddycomCallSettingInfo: {
                gifCategoryTypeValue: "",
                imageUrl: callCameraOff, // デフォルト画像
            }
        }
    },

    // ライフサイクル
    created: function () {
        this.checkBuddycomCallNumberContract();
        return;
    },

    methods: {

        // DBからBuddycom通話設定情報を取得し、画面に反映する
        getInfo() {
            let self = this;

            // GIFカテゴリ一覧を初期化
            this.gifCategoryList = commonUtil.getGifCategoryTypeList(this.$i18n);

            // 設定データをサーバから取得
            server.post('/getbuddycomcallsetting')
                .then((res) => {
                    const settingBuddycomCall = res.data;
                    switch (settingBuddycomCall.status) {
                        case constants.STATUS_SUCCESS:
                            // 取得成功時：画面のデータに反映
                            self.showBuddycomCallSetting = false; // 編集モーダルは閉じておく
                            self.buddycomCallSettingInfo.gifCategoryTypeValue = settingBuddycomCall.gifCategory;
                            self.gifSelectedType = self.gifCategoryList.find(item => item.value === settingBuddycomCall.gifCategory);
                            // デフォルト値の場合、imageUrl = null
                            if (settingBuddycomCall.imageUrl != null) {
                                self.buddycomCallSettingInfo.imageUrl = settingBuddycomCall.imageUrl;
                            }
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            this.show = !!settingBuddycomCall.hasLicense;
                            break;
                        default:
                            // その他エラー
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getInfo").replace("{code}", res.data.status));
                            break;
                    }
                })
        },

        checkBuddycomCallNumberContract() {
            if (this.appData.enableBuddyComCall || this.appData.enableBuddyComCallTrial) {
                this.show = true;
                this.getInfo()
            } else {
                this.show = false;
            }
        },

        // ブラウザ互換性チェックを行い、問題なければ設定編集モーダルを表示する
        checkBrowserToShowBuddycomCallSetting() {
            var userAgent = window.navigator.userAgent.toLowerCase();
            if ((userAgent.indexOf('msie') !== -1) ||
                (userAgent.indexOf('trident') !== -1)) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_browser"));
                return;
            }
            this.showBuddycomCallSetting = true;
        },

        /**
         * 設定情報の更新処理（子コンポーネントで保存ボタン押下時に呼ばれる）
         * @param buddycomCallSettingRequest 更新内容（子コンポーネントから受け取る）
         * @param namedFile
         */
        modifyBuddycomCallSetting(buddycomCallSettingRequest, namedFile) {
            this.showBuddycomCallSetting = false; // モーダルを閉じる

            // 設定をサーバに保存
            server.postWithFile('/modifybuddycomcallsetting', namedFile, JSON.stringify(buddycomCallSettingRequest))
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            // 成功時：画面表示を更新
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "item_buddycom_call_setting_added"));
                            this.buddycomCallSettingInfo.gifCategoryTypeValue = buddycomCallSettingRequest.gifCategory;
                            this.gifSelectedType = this.gifCategoryList.find(item => item.value === buddycomCallSettingRequest.gifCategory);
                            this.buddycomCallSettingInfo.imageUrl = buddycomCallSettingRequest.previewUrl;
                            this.getInfo();
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_call_upload_file_too_big_custom").replace("{maxSize}", "10MB"));
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "modifybuddycomcallsetiing").replace("{code}", res.data.status));
                            break;
                    }
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(this, "modifybuddycomcallsetiing", error);
                })
        }
    },

    watch: {
        'appData.enableBuddyComCall'(newVal) {
            if (newVal) {
                this.checkBuddycomCallNumberContract();
            }
        },
        'appData.enableBuddyComCallTrial'(newVal) {
            if (newVal) {
                this.checkBuddycomCallNumberContract();
            }
        },
    },

    props: ['appData']

}

</script>

<style scoped>
.object-right-value {
    width: 65%;
    text-align: right;
    vertical-align: middle;
    padding-right: 30px;
    color: #848991;
}

.object-right-value-image-container {
    height: 100%;
    display: flex;
    align-items: center;
}

.object-right-value-image {
    max-width: 300px;
    max-height: 300px;
    object-fit: contain
}

</style>
